module.exports = __webpack_public_path__ + "static/media/gts13.3351afea.png";